import Dispatcher from '../../../flux/dispatcher/dispatcher';
import Constants from '../constant/Constant';
var EventEmitter = require('events').EventEmitter;
var RESPONSE_CHANGE_EVENT = 'globalResponse';
var assign = require('object-assign');

var response = {};

function parseResponse(resp) {
    response = resp;
}

function parseError(resp) {
    response = { sendForApproval: false, assignedForAllEditors: true, delayOption: 'TENMINUTES', assignedEditors: [] }
}

var GetProfileSettingsStore = assign({}, EventEmitter.prototype, {
    emitChangeEvent: function (event) {
        this.emit(event);
    },
    bind: function (callback) {
        this.on(RESPONSE_CHANGE_EVENT, callback);
    },
    unbind: function (callback) {
        this.removeListener(RESPONSE_CHANGE_EVENT, callback);
    },
    getResponse: function () {
        return response;
    }
});

Dispatcher.register(function (action) {

    switch (action.actionType) {
        case Constants.PROFILE_SETTINGS_RECEIVED:
            var resp = action.data;
            parseResponse(resp)
            GetProfileSettingsStore.emitChangeEvent(RESPONSE_CHANGE_EVENT);
            break;
        case Constants.PROFILE_SETTINGS_ABSENT:
            var resp = action.data;
            parseError(resp)
            GetProfileSettingsStore.emitChangeEvent(RESPONSE_CHANGE_EVENT);

            break;
        default:
    }
});

export default GetProfileSettingsStore;